const DOCUMENT = 'EDIT_ACCREDITATION_';

const actions = {
  LOAD_DATA_REQUEST: DOCUMENT + 'LOAD_DATA_REQUEST',
  LOAD_DATA_SUCCESS: DOCUMENT + 'LOAD_DATA_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  UPDATE_DATA_REQUEST: DOCUMENT + 'UPDATE_DATA_REQUEST',
  UPDATE_DATA_SUCCESS: DOCUMENT + 'UPDATE_DATA_SUCCESS',
  UPDATE_DATA_ERROR: DOCUMENT + 'UPDATE_DATA_ERROR',
  TOUCH: DOCUMENT + 'TOUCH',

  loadAccreditationRequest: data => ({
    type: actions.LOAD_DATA_REQUEST,
    payload: data,
  }),

  loadAccreditationSuccess: data => ({
    type: actions.LOAD_DATA_SUCCESS,
    payload: data,
  }),

  updateAccreditationRequest: data => ({
    type: actions.UPDATE_DATA_REQUEST,
    payload: data,
  }),

  updateAccreditationSuccess: data => ({
    type: actions.UPDATE_DATA_SUCCESS,
    payload: data,
  }),

  updateAccreditationError: data => ({
    type: actions.UPDATE_DATA_ERROR,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
